import clsx from 'clsx'
import { IIconBackgroundProps } from './types'
import styles from './styles.module.scss'

const IconBackground = ({
  icon,
  className = '',
  id,
  size = 'md',
  style,
  variant = 'circle',
  ...props
}: IIconBackgroundProps) => {
  return (
    <div
      className={clsx(
        'mui-icon-background',
        styles.iconBackground,
        styles[size],
        styles[variant],
        className,
      )}
      data-testid="mui-icon-background"
      id={id}
      style={{ ...style }}
      {...props}
    >
      {icon}
    </div>
  )
}

export default IconBackground
